import React from "react";
import {Form, Input, Button, Checkbox, Row} from 'antd';
import {UserOutlined, LockOutlined, ApartmentOutlined} from '@ant-design/icons';
import './login.css'
import logo from '../../assets/infocop.png'
import {UnauthenticatedPostToApi} from "../../helpers/api";
import {isLoggedIn, LogoutUser, setUser} from "../../helpers/authentication";
import {useHistory} from "react-router-dom";

function Login() {
    LogoutUser()
    let history = useHistory();
    const onFinish = (values) => {
        UnauthenticatedPostToApi('/api/Authentication/login',values).then(r => {
            if(r && r.userValidation){
                if(r.otpValidation){
                    setUser(r.apikey, r.account)
                    history.push('/')
                }else{
                    //ask for OTP Token
                }
            }else{
                alert("Authentication Failed")
            }
            console.log(r)
        })
    };
    
    return (
        <Row type="flex" justify="center" align="middle" style={{minHeight: '100vh'}}>

            <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
            >
                <img src={logo} alt={""} style={{width:"200px", marginBottom:"10px"}} />
                <Form.Item
                    name="UnitCode"
                    rules={[{ required: true, message: 'Unit Code is Required' }]}
                >
                    <Input prefix={<ApartmentOutlined  className="site-form-item-icon" />} placeholder="Muni Code" />
                </Form.Item>
                
                <Form.Item
                    name="EmpId"
                    rules={[{ required: true, message: 'Info-Cop User ID is Required' }]}
                >
                    <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Info-Cop User ID" />
                </Form.Item>
                <Form.Item
                    name="Password"
                    rules={[{ required: true, message: 'Info-Cop Password  is Required' }]}
                >
                    <Input
                        prefix={<LockOutlined className="site-form-item-icon" />}
                        type="password"
                        placeholder="Info-Cop Password"
                    />
                </Form.Item>
                
                <Form.Item>
                    <Button type="link" htmlType="submit" className="login-form-button">
                        Login
                    </Button>
                </Form.Item>
            </Form>
        </Row>
    );
}

export default Login;